<template>
  <v-bottom-sheet v-model="model" scrollable>
    <v-sheet class="text-center pa-md-8 mx-lg-auto" height="auto">
      <v-btn color="error" dark small @click="model = false"> Fechar </v-btn>

      <h2 class="mt-4">Aulas conflitadas</h2>

      <v-simple-table class="mt-4" style="border: 1px solid #e0e0e0">
        <thead style="background-color: #e0e0e0">
          <tr>
            <th>#</th>
            <th>Professor</th>
            <th>Situação</th>
            <th>Data</th>
            <th>Turma</th>
            <th>Disciplina</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="item in aulas" :key="item.id">
            <td>{{ item.id }}</td>

            <td>
              {{ item.professor.nome }}
              <br />
              <v-chip color="grey" dark x-small>
                {{ item.turma.franquia.descricao }}
              </v-chip>
            </td>

            <td>{{ item.situacao ? item.situacao : "Aguardando" }}</td>

            <td>
              {{ item.data.split("-").reverse().join("/") }}
            </td>

            <td>{{ item.turma.descricao }}</td>

            <td>{{ item.disciplina.descricao }}</td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-sheet>
  </v-bottom-sheet>
</template>

<script>
export default {
  props: {
    value: Boolean,
    aulas: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    model: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>
